
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nft-toy-box",
      function () {
        return require("private-next-pages/nft-toy-box.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nft-toy-box"])
      });
    }
  